import Layout from '../../internal/Layout.vue'
import ReplacementStudy from './index.vue'

const replacementStudyRoutes = {
  component: Layout,
  children: [
    {
      name: 'replaceStudy',
      path: '/',
      component: ReplacementStudy,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: false,
        requiresLaboratory: true,
      },
    },
  ],
}

export default replacementStudyRoutes
